import { createSlice } from '@reduxjs/toolkit';
import { getCurrencySymbolAndFormat } from './currency-formatter-actions';

const initialState = {
    formatter: await getCurrencySymbolAndFormat()
}

// Create a slice
const currencyFormatterSlice = createSlice({
    name: 'currencyFormatter',
    initialState
});

export const { } = currencyFormatterSlice.actions;

// Export reducer
export default currencyFormatterSlice.reducer;
